import React from 'react';

import './ContactUs.css';
import SupportLink from './Components/SupportLink/SupportLink';
import ContactForm from './Components/ContactForm/ContactForm';
function ContactUs() {
  return (
    <div className="page-layout">
      <main className="page-content">
        <div className="contact-section">
          <div className="contact-info">
            <h1 className="contact-title">Contact Sendbird</h1>
            <p className="contact-subtitle">
              Have a question? Please let us know how we can help. If you are looking for information about our products, please contact our <a href="#" className="sales-link">sales team</a>.
            </p>
          </div>
          <div className="contact-form-wrapper">
            <ContactForm />
          </div>
        </div>
        <SupportLink />
      </main>
    </div>
  );
}

export default ContactUs;